import React from 'react';
import { Text } from '../Text';

const MarketingProductPreview = ({ content, footer, productType, productThumbnail }) => {
  const getCTALabel = () => {
    switch (productType) {
      case 'CATALOG':
        return 'View catalog';
      case 'MULTI':
        return 'View items';
      case 'SINGLE':
        return 'View';
      default:
        return 'View';
    }
  };

  return (
    <>
      {/* BODY */}
      <div className="mx-2 mt-2 p-2">
        {/* THUMBNAIL */}
        {productType !== 'SINGLE' && productThumbnail && (
          <img
            src={URL.createObjectURL(productThumbnail)}
            alt="thumbnail"
            style={{
              width: '100%',
              maxHeight: '160px',
              objectFit: 'cover',
              borderRadius: '8px',
              marginBottom: '8px',
            }}
          />
        )}

        {/* BODY TEXT */}
        {content && (
          <Text type="sub-heading" style={{ whiteSpace: 'pre-line' }}>
            {content}
          </Text>
        )}

        {/* FOOTER */}
        {productType === 'SINGLE' && footer && (
          <Text type="sub-heading" color="grey" style={{ fontSize: '0.8rem' }}>
            {footer}
          </Text>
        )}
      </div>

      {/* CTA */}
      <div className="mx-2 mb-2">
        <div
          className="p-2 text-center"
          style={{
            background: '#f5f6f7',
            borderRadius: '10px',
          }}
        >
          <Text type="sub-heading" color="#25D366">
            {getCTALabel()}
          </Text>
        </div>
      </div>
    </>
  );
};

export default MarketingProductPreview;
